import Vue from "vue";
import { charts as api } from "@lab/api/charts.api";
import Bugsnag from "@/utils/bugsnag";

const state = {
	charts: [],
	fetched: null,
	fetching: false
};

const getters = {
	charts: (state) => state.charts,
	fetchedd: (state) => state.fetchedd,
	fetching: (state) => state.fetching
};

const actions = {
	async fetch({ commit, getters }) {
		if (getters.charts.length > 1) {
			return true;
		}

		commit("LOAD_START");

		const _charts = await api.fetch().catch((error) => {
			Bugsnag.notify(
				new Error(`Charts fetch: ${error.response.data.error}`)
			);
		});

		commit("SET_CHARTS", _charts);

		commit(`LOAD_FINISH`);
	}
};

const mutations = {
	SET_CHARTS(state, charts) {
		Vue.set(state, "charts", charts);
	},
	LOAD_FINISH(state: any) {
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
